import TextBlock from "../../typeComponents/TextBlock";
import MainHeading from "../../typeComponents/MainHeading";
import Paragraph from "../../typeComponents/Paragraph";
import { Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CureLogoCleanVector from "../../images/CURE_logo_clean_vector.svg";

const ResourcesButton = ({ title, route }) => {
  return (
    <Button
      variant="contained"
      sx={{
        color: "primary.contrastText",
        minWidth: "150px",
        marginBottom: "20px",
      }}
      component={RouterLink}
      to={route}
    >
      {title}
    </Button>
  );
};

const Resources = () => {
  return (
    <TextBlock>
      <MainHeading>Resources</MainHeading>
      <Box sx={{ width: { xs: "45vw", md: "24vw" }, padding: "10px" }}>
        <img src={CureLogoCleanVector} alt="CURE Montreal Logo" />
      </Box>
      <Paragraph>
        {/* This pragraph is temporary! */}
        Hiya! Below are links to the materials from some of the workshops we
        give. Feel free to refresh your memory, or learn someething new!
      </Paragraph>
      <ResourcesButton
        title={"Get Money for Projects!"}
        route={"/grantwriting"}
      />
      <ResourcesButton title={"Make it Happen!"} route={"/project-planning"} />
    </TextBlock>
  );
};

export default Resources;
